module.exports = __webpack_public_path__ + "static/hero3-0470cd1b4b2d192a65cfff01c2235c6f.jpg";